<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Login -->
    <login-field
      v-model="$attrs.user.login"
      :error="$attrs.errors.user.login"
    />

    <!-- Password -->
    <password-field
      v-model="$attrs.user.password"
      :error="$attrs.errors.user.password"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import loginField from '@/components/forms/privat_auth/fields/Login'
import passwordField from '@/components/forms/privat_auth/fields/Password'

export default {
  name: 'privat-auth-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    }
  },
  components: {
    loginField,
    passwordField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrivatAuthBlankForm.vue?d052397e